import React from "react";

const PayStatusPopup = ({ status, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        {"success" === status ? (
          <div className="text-center">
            <svg
              className="w-16 h-16 mx-auto text-green-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m0 0a9 9 0 11-9 9 9 9 0 119-9z"
              />
            </svg>
            <h2 className="mt-4 text-xl font-semibold">Payment Successful</h2>
            <p className="mt-2 text-gray-600">Thank you for your payment.</p>
          </div>
        ) : (
          <div className="text-center">
            <svg
              className="w-16 h-16 mx-auto text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M18.364 5.636a9 9 0 11-12.728 0 9 9 0 0112.728 0zm-7.778 4.95l2.122 2.122M9.192 9.192l2.122 2.122m2.122 0l2.122 2.122M12 12.414l2.122-2.122m0 0L9.192 9.192"
              />
            </svg>
            <h2 className="mt-4 text-xl font-semibold">Payment Failed</h2>
            <p className="mt-2 text-gray-600">Please try again.</p>
          </div>
        )}
        <button
          onClick={onClose}
          className="mt-6 w-full py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition duration-300"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default PayStatusPopup;
